module.exports = __webpack_public_path__ + "img/x.cb57f1b5.jpg";